import { ContextualInfoButton } from "@/components/buttons/ContextualInfoButton";
import { formatAbbreviatedValue } from "@/utils/number";
export type StatsProps = {
  label: string | React.ReactNode;
  value: string | number;
  footer?: string | React.ReactNode;
  unit?: string;
  unitPosition?: "start" | "end";
  icon?: React.ReactNode;
  compact?: boolean;
  tag?: React.ReactNode;
  contextId?: string;
  /** Shows a greyed "N/A" in place of the value, for metrics not calculated for the selection. */
  notApplicable?: boolean;
};
export const Stats = ({
  label,
  value,
  footer,
  unit,
  unitPosition = "end",
  icon,
  compact = false,
  tag,
  contextId,
  notApplicable = false
}: StatsProps) => {
  const formatted = formatAbbreviatedValue(value, unit);
  const isNegative = typeof formatted === "string" && formatted.startsWith("-");
  const displayValue = isNegative ? formatted.slice(1) : formatted;
  return <div className="flex h-full flex-col justify-between gap-1 rounded-2xl border border-gray-200 bg-surface p-3 shadow-sm @3xl:p-4" data-sentry-component="Stats" data-sentry-source-file="Stats.tsx">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 text-sm font-medium tracking-[-0.01em] text-gray-900">
          {label}
          {contextId && <ContextualInfoButton className="items-end !text-xs" rootClassName="!inline-flex !ml-1" id={contextId} />}
        </div>
        {tag && <div>{tag}</div>}
      </div>
      <div className="flex flex-col justify-between gap-1">
        <div className={`mt-2 font-semibold tracking-[-0.015em] text-gray-900 ${compact ? "text-xl @xl:text-2xl @4xl:text-xl @5xl:text-2xl" : "text-2xl @xl:text-3xl @3xl:text-4xl"}`}>
          {notApplicable ? <span className="text-gray-400">N/A</span> : <>
              {icon && <span className="text-xs text-gray-400">{icon}</span>}

              {unit && unitPosition === "start" && <span className="mr-0.5 text-base text-gray-400">
                  {isNegative && "-"}
                  {unit}
                </span>}
              {displayValue}
              {unit && unitPosition === "end" && <span className="ml-0.5 text-base text-gray-400">{unit}</span>}
            </>}
        </div>
        {footer && <div className="text-xs font-medium text-gray-400">{footer}</div>}
      </div>
    </div>;
};